module.exports = __webpack_public_path__ + "img/exam-content-exam.c45db140.png";